import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import Select from 'react-select';
import useDataBean from '../../../core/services/dataBean/useDataBean';
import { _single, _WorkActivityGroup } from '../../../core/services/dataBean/EntityCatalog';


interface Props {
    idSelector: number;
    onChange: any;
    IDAccount: number;
    label?: string;
    returnType?: "ID" | "Object";
}

export const SelectWorkActivityGroupByIDAccount = ({ idSelector, onChange, label, returnType = "ID", IDAccount }: Props) => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_WorkActivityGroup);
    const [selectedOption, setSelectedOption] = useState<any>(null);

    useEffect(() => {
        if (IDAccount) {
            getLista();
        }
    }, [IDAccount]);

    useEffect(() => {
        if (idSelector && lista.length > 0) {
            const found = lista.find(item => item.DataBeanProperties.IDWorkActivityGroup === idSelector);
            if (found) {
                setSelectedOption({
                    value: found.DataBeanProperties.IDWorkActivityGroup,
                    label: found.DataBeanProperties.GroupName,
                    item: found
                });
            }
        }
    }, [idSelector, lista]);

    const getLista = () => {
        instance.getGroupsByAccount(IDAccount).then(
            (resp: any) => {
                if (resp) setLista(resp);
            }).catch(err => toast.error(err));
    };

    const handleChange = (option: any) => {
        setSelectedOption(option);
        if (!option) {
            if (onChange)
                onChange(returnType === "Object" ? {} : null);
        } else {

            if (onChange) {
                onChange(returnType === "Object" ? option.item.DataBeanProperties : option.value);
            }
        }
    };

    const options = lista.map((item: any) => ({
        value: item.DataBeanProperties.IDWorkActivityGroup,
        label: item.DataBeanProperties.GroupName,
        item: item
    }));

    return (
        <div>
            {label && label != " " &&
                < label > {label ?? "Mis grupos de Trabajo"}</label>
            }
            <Select
                options={options}
                value={selectedOption}
                onChange={handleChange}
                isClearable
                placeholder="Selecciona un Grupo de Trabajo..."
                noOptionsMessage={() => "Sin coincidencias"}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                styles={{
                    menuPortal: base => ({ ...base, zIndex: 1100 })
                }}
            />
        </div >
    );
};
